import React from "react";
import { brushImage } from "../mock";

const About = () => {
  return (
    <section id="about" className="py-24 md:py-32 bg-sand relative overflow-hidden">
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <div className="grid md:grid-cols-2 gap-12 md:gap-20 items-center">
          <div className="relative">
            <div className="overflow-hidden">
              <img
                src={brushImage}
                alt="Morgane"
                className="w-full h-[500px] md:h-[650px] object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-8 -right-4 md:-right-8 bg-cream px-8 py-6 border border-gold/30 hidden md:block">
              <p className="font-vibes text-gold-dark text-3xl leading-none">Morgane</p>
              <p className="font-serif text-[10px] tracking-[0.3em] text-brown mt-2">FONDATRICE</p>
            </div>
          </div>

          <div>
            <p className="font-serif text-[11px] tracking-[0.35em] text-gold-dark mb-6">
              L'INSTITUT
            </p>
            <h2 className="font-serif text-3xl md:text-5xl text-brown leading-tight mb-4">
              L'exigence de la <br />
              <span className="font-cormorant italic text-gold-dark">qualité,</span>
            </h2>
            <p className="font-serif text-xl md:text-2xl text-brown mb-8">
              au cœur de votre <span className="font-vibes text-gold-dark text-3xl">expérience</span>
            </p>

            <div className="gold-divider justify-start mb-8" style={{ justifyContent: "flex-start" }}>
              <span className="w-12 h-px bg-gold/60" />
              <span className="w-1 h-1 rounded-full bg-gold" />
            </div>

            <p className="font-cormorant text-brown/85 text-lg leading-relaxed mb-5">
              Chez <span className="font-semibold">Maison Morgane</span>, chaque détail compte. Je vous accueille dans un institut privé, où douceur, discrétion et savoir-faire se rencontrent pour vous offrir une véritable parenthèse de bien-être.
            </p>
            <p className="font-cormorant text-brown/85 text-lg leading-relaxed mb-8">
              Passionnée par la beauté et le bien-être, j'ai fait le choix de travailler avec <span className="font-semibold">Peggy Sage</span>, une marque professionnelle reconnue dans l'univers de la beauté et de l'esthétique depuis 1925.
            </p>

            <div className="grid grid-cols-2 gap-6 pt-6 border-t border-gold/20">
              <div>
                <p className="font-vibes text-3xl text-gold-dark">Sur mesure</p>
                <p className="font-serif text-[10px] tracking-[0.25em] text-brown mt-1">CHAQUE SOIN EST ADAPTÉ</p>
              </div>
              <div>
                <p className="font-vibes text-3xl text-gold-dark">Depuis 1925</p>
                <p className="font-serif text-[10px] tracking-[0.25em] text-brown mt-1">PARTENAIRE PEGGY SAGE</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
